import { styles, InformationRowsVariants } from './InformationRows.css'
import { InformationRow } from '../InformationRow/InformationRow'
import { AppText } from '../../AppText'

interface InformationRowsProps extends InformationRowsVariants {
	table: any[]
}

export const InformationRows: React.FC<InformationRowsProps> = ({ table }) => {
	const { tableClass, topRow } = styles()

	return (
		<div className={tableClass()}>
			<div className={topRow()}>
				<AppText className="col-span-3" size="h3" family="condensed" textTransform="uppercase">
					Solvent
				</AppText>
				<AppText className="col-span-2" size="h3" family="condensed" textTransform="uppercase">
					Hazard
				</AppText>
				<AppText size="h3" family="condensed" textTransform="uppercase" className="hidden">
					Bio-content
				</AppText>
			</div>
			{table.map((row, idx) => (
				<InformationRow key={idx} row={row} />
			))}
		</div>
	)
}
